const auditLoadEvents = {
    Loading: {
        Name: "WALKTHRULOAD.LOADING",
        New(type, facNumber, guid) {
            return {
                type: auditLoadEvents.Loading.Name,
                SurveyID: guid,
                SurveyType: type,
                SurveyFacilityNumber: facNumber
            };
        }
    },
    Loaded: {
        Name: "WALKTHRULOAD.LOADED",
        New(data) {
            return {
                type: auditLoadEvents.Loaded.Name,
                Data: data
            };
        }
    },
    LoadErrored: {
        Name: "WALKTHRULOAD.LOADERRORED",
        New(error) {
            return {
                type: auditLoadEvents.LoadErrored.Name,
                Error: error
            };
        }
    }
};

module.exports = auditLoadEvents;


// WEBPACK FOOTER //
// ./src/events/walkThruLoad/walkThruLoadEvents.js